import { Driver, DriverHook } from "driver.js";
import { defaultTourConfig } from ".";

// Export the tour steps so they can be reused in BrandGrandTour
export const brandSupportTourSteps = [
  {
    element: "#support",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
          <div class="flex -space-x-2">
            <div class="w-6 h-6 bg-brand-200 rounded-full border-2 border-white flex items-center justify-center">
              <svg class="w-3 h-3 text-brand-600" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
              </svg>
            </div>
            <div class="w-6 h-6 bg-brand-300 rounded-full border-2 border-white flex items-center justify-center">
              <svg class="w-3 h-3 text-brand-700" fill="currentColor" viewBox="0 0 24 24">
                <path d="M3 17l6-6 4 4 8-8v3h2V4h-6v2h3l-7 7-4-4-6 6v2z"></path>
              </svg>
            </div>
            </div>
        </div>
        <div class="flex items-center gap-2">
          <span class="text-base font-semibold text-foreground">Support & Help</span>
        </div>
      </div>`,
      description: `<div class="space-y-3">
    <p class="text-[12px] text-muted-foreground leading-relaxed">Here you can contact our support team for any questions or issues.</p>
    <div class="bg-brand-50 p-3 rounded-lg border-l-4 border-brand-400">
      <div class="flex items-start gap-2">
        <svg class="w-4 h-4 text-brand-600 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        <p class="text-xs text-brand-800 font-medium">Our support team is here to help you with any questions or issues.</p>
      </div>
    </div>
  </div>`,
      side: "right" as const,
      align: "start" as const,
    },
  },
];

const startSupportTour = (
  tourDriver: Driver,
  onNextClick: DriverHook,
  onPrevClick: DriverHook
) => {
  tourDriver.setConfig(defaultTourConfig);
  // Here we set the unique steps for the FIRST tour
  tourDriver.setSteps(
    brandSupportTourSteps.map((step) => ({
      ...step,
      popover: {
        ...step.popover,
        onNextClick: (element, step, config) => {
          onNextClick(element, step, config);
          setTimeout(() => {
            tourDriver.moveNext();
          }, 200);
        },
        onPrevClick: (element, step, config) => {
          onPrevClick(element, step, config);
          setTimeout(() => {
            tourDriver.movePrevious();
          }, 200);
        },
      },
    }))
  );
  tourDriver.drive();
};

export default startSupportTour;
